module.exports = __webpack_public_path__ + "img/pingMsg.119ef766.png";